import { fromJS } from 'immutable';
import { JWPLAYER_ACTION_TYPES } from './jwplayerActions';


export const STATE_KEY = "jwplayer";

const INITIAL_STATE = fromJS({
  players: [],
  isInitialized: false,
  sdkLoading: false,
});

function sdkLoaded(state) {
  return state.set('isInitialized', true);
}

function sdkStartLoading(state) {
  return state.set('sdkLoading', true);
}

const handlers = {
  [JWPLAYER_ACTION_TYPES.SDK_LOADED]: sdkLoaded,
  [JWPLAYER_ACTION_TYPES.LOAD_SDK]: sdkStartLoading
};

export function isInitializedSelector(state) {
  return state[STATE_KEY].get('isInitialized');
}

export function sdkLoadingStateSelector(state) {
  return state[STATE_KEY].get('sdkLoading');
}

export function jwplayerReducer(state = INITIAL_STATE, action) {
  return handlers[action.type] && handlers[action.type](state, action.payload) || state;
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/jwplayer/jwplayerReducer.js